/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste labels and values to build a donut chart — a pie chart with the centre removed, which many find cleaner and leaves room for a total in the middle.`)
};

const es_donut_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega etiquetas y valores para crear un gráfico de dona — un gráfico circular con el centro eliminado, que muchos consideran más limpio y deja espacio para un total en el medio.`)
};

const de_donut_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie Bezeichnungen und Werte ein, um ein Donut-Diagramm zu erstellen — ein Kreisdiagramm mit entfernter Mitte, das viele als übersichtlicher empfinden und das Platz für eine Gesamtsumme in der Mitte lässt.`)
};

const nl_donut_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak labels en waarden om een donutdiagram te bouwen — een cirkeldiagram met het midden verwijderd, wat velen overzichtelijker vinden en ruimte laat voor een totaal in het midden.`)
};

const fr_donut_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez des étiquettes et des valeurs pour créer un diagramme en anneau — un diagramme circulaire dont le centre est retiré, ce que beaucoup trouvent plus épuré et qui laisse de la place pour un total au centre.`)
};

const it_donut_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla etichette e valori per costruire un grafico a ciambella — un grafico a torta con il centro rimosso, che molti trovano più pulito e lascia spazio per un totale al centro.`)
};

const pt_br2_donut_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole rótulos e valores para criar um gráfico de rosca — um gráfico de pizza com o centro removido, que muitos consideram mais limpo e deixa espaço para um total no meio.`)
};

const pt_donut_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole rótulos e valores para construir um gráfico de rosca — um gráfico circular com o centro removido, que muitos consideram mais limpo e deixa espaço para um total no meio.`)
};

const ja_donut_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベルと値を貼り付けるとドーナツグラフが作成されます — 中央を取り除いた円グラフで、よりすっきりして見え、中央部に合計を表示するスペースを残せます。`)
};

const zh_donut_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴标签和数值以构建环形图——一种去掉中心的饼图，许多人认为它更简洁，中心空白处还可以放置总计数字。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_intro", locale)
	if (locale === "en") return en_donut_intro(inputs)
	if (locale === "es") return es_donut_intro(inputs)
	if (locale === "de") return de_donut_intro(inputs)
	if (locale === "nl") return nl_donut_intro(inputs)
	if (locale === "fr") return fr_donut_intro(inputs)
	if (locale === "it") return it_donut_intro(inputs)
	if (locale === "pt-BR") return pt_br2_donut_intro(inputs)
	if (locale === "pt") return pt_donut_intro(inputs)
	if (locale === "ja") return ja_donut_intro(inputs)
	return zh_donut_intro(inputs)
};